(function () {
  'use strict';
  function isPreview() {
    var query = new URLSearchParams(window.location.search);
    var shop = window.Shopify;
    return query.has('preview_theme_id') || query.get('article_qa') === '1' || query.get('seo_qa') === '1' ||
      Boolean(shop && (shop.designMode || (shop.theme && shop.theme.role && shop.theme.role !== 'main')));
  }
  if (document.__skArticleCommerce || !document.querySelector('[data-sk-article-commerce="true"]')) return;
  if (isPreview()) return;
  document.__skArticleCommerce = true;

  try {
    if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
    }
  } catch (_) { /* A missing consent API leaves tracking disabled. */ }

  function trackClick(event) {
    try {
      if (isPreview() || !event.isTrusted || event.defaultPrevented) return;
      if (event.type === 'click' ? event.button !== 0 : event.button !== 1) return;
      var target = event.target.nodeType === 3 ? event.target.parentElement : event.target;
      var link = target.closest && target.closest('a[href]');
      if (!link || !link.closest('[data-sk-article-commerce="true"]')) return;
      if (link.hasAttribute('download') || link.closest('[hidden], [inert], [aria-hidden="true"], [aria-disabled="true"]')) return;
      var shopify = window.Shopify;
      if (!shopify || shopify.designMode || !shopify.customerPrivacy || shopify.customerPrivacy.analyticsProcessingAllowed() !== true) return;

      var url = new URL(link.getAttribute('href'), window.location.href);
      if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) return;
      if (![window.location.hostname, 'skhonpo.com', 'www.skhonpo.com'].includes(url.hostname)) return;
      var path = url.pathname.replace(/\/$/, '');
      var name;
      if (/^\/products\/[^/]+$/.test(path) || /^\/collections\/[^/]+\/products\/[^/]+$/.test(path)) name = 'article_product_click';
      else if (/^\/collections\/[^/]+$/.test(path)) name = 'article_collection_click';
      else if (path === '/pages/contact') name = 'article_contact_click';
      else if (['/pages/pre-purchase-consultation', '/pages/bambu-lab-corporate-consultation'].includes(path)) name = 'article_consultation_click';
      else if (path === '/pages/catalog-download') name = 'article_catalog_click';
      if (!name) return;

      // Only public catalog keys are retained. Never infer a selected variant
      // from a product-only link, or forward arbitrary URL/query/text content.
      var parameters = { link_location: 'article_body' };
      if (name === 'article_product_click') {
        var productPath = path.match(/^\/(?:collections\/[a-z0-9_-]+\/)?products\/([a-z0-9_-]{1,100})$/);
        if (!productPath) return;
        parameters.product_handle = productPath[1];
        var variants = url.searchParams.getAll('variant');
        if (variants.length === 1 && /^[1-9][0-9]{0,14}$/.test(variants[0])) {
          parameters.product_variant_id = variants[0];
          parameters.product_link_type = 'variant';
        } else {
          parameters.product_link_type = variants.length ? 'invalid_variant' : 'product';
        }
      }
      if (typeof window.gtag === 'function') window.gtag('event', name, parameters);
      else if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, parameters));
    } catch (_) { /* Analytics must never interrupt navigation. */ }
  }

  document.addEventListener('click', trackClick);
  document.addEventListener('auxclick', trackClick);
}());
